module.exports = __webpack_public_path__ + "static/img/icon_statistics_normal.4050b733.svg";